module.exports = __webpack_public_path__ + "static/nik.ebdec45b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nik.jpg
// module id = 672
// module chunks = 168707334958949